import { createStore, applyMiddleware, compose } from 'redux';
import combinedReducer from './reducer'
import thunk from 'redux-thunk';

const initialState = {}
const store = createStore(combinedReducer, initialState,
    compose(
        applyMiddleware(thunk),
        window.devToolsExtension ? window.devToolsExtension() : f => f
    ))
export default store